module.exports = __webpack_public_path__ + "media/images/pages/secondary-toolkit/tori-13337a5b20830bf822ebb1417f5b1722.png";